import script from "./TheCriteria.vue?vue&type=script&setup=true&lang=js"
export * from "./TheCriteria.vue?vue&type=script&setup=true&lang=js"

import "./TheCriteria.vue?vue&type=style&index=0&id=284fde5c&scoped=true&lang=css"

import exportComponent from "D:\\Работа\\vue3\\_hackatons\\latest_version\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-284fde5c"]])

export default __exports__